import { Card, List, Spin, Select, Tooltip, Empty, Skeleton, Tag } from 'antd'
import React from 'react'
import usePermissions from '../../hooks/usePermissions';

const { Option } = Select;

const HelpDocView = ({ loading, data, selectedDoc, setSelectedDoc, isMobile, singledata, singleLoading }) => {

    const { hasPermission } = usePermissions();
    return (
        <div>
            {loading ? (
                <Spin />
            ) : (
                <div
                    style={{
                        width: "100%",
                        height: "70vh",
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        gap: "20px",
                        overflow: "hidden",
                    }}
                >
                    {isMobile && (
                        <div
                            style={{
                                width: "100%",
                                padding: "10px",
                                backgroundColor: "#fafafa",
                                borderRadius: "8px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                marginBottom: "10px",
                            }}
                        >
                            <Select
                                defaultValue={selectedDoc}
                                style={{ width: "100%" }}
                                onChange={(uid) => setSelectedDoc(uid)}
                            >
                                {data?.map((item) => (
                                    <Option key={item?.uid} value={item?.uid}>
                                        {item?.feature_name}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    )}

                    <div
                        style={{
                            flex: 1,
                            overflowY: "auto",
                            paddingRight: "10px",
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                        }}
                        className="custom-scroll-hide"
                    >
                        {selectedDoc ? (
                            <Card
                                loading={singleLoading}
                                style={{ textAlign: "left", }}
                                title={
                                    singleLoading ? (
                                        <Skeleton.Input style={{ width: 200, height: 20 }} active size="small" />
                                    ) : (
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}
                                        >
                                            <div>{singledata?.feature_name || "Untitled"}</div>
                                            {hasPermission("can_view_help_doc_published_flag") &&
                                                "is_published" in singledata && (
                                                    <Tag color={singledata.is_published ? "green" : "red"}>
                                                        {singledata.is_published ? "Published" : "Unpublished"}
                                                    </Tag>
                                                )}
                                        </div>
                                    )
                                }
                                bordered={false}
                            >
                                <div
                                    style={{ marginTop: "-20px" }}
                                    dangerouslySetInnerHTML={{
                                        __html: singledata?.description
                                            .replace(/<br\s*\/?>/gi, "")
                                            .replace(/<p[^>]*>(&nbsp;|\s)*<\/p>/gi, ""),
                                    }}
                                />
                            </Card>
                        ) : (
                            <div style={{ padding: "20px" }}>
                                <Empty description="No Data Available" />
                            </div>
                        )}
                    </div>

                    {!isMobile && (
                        <div
                            style={{
                                width: "280px",
                                overflowY: "auto",
                            }}
                            className="custom-scroll-hide"
                        >
                            <List
                                dataSource={data}
                                renderItem={(item) => (
                                    <List.Item
                                        key={item?.uid}
                                        style={{
                                            padding: "10px",
                                            marginBottom: "8px",
                                            borderRadius: "6px",
                                            backgroundColor:
                                                selectedDoc === item?.uid ? "#36c6d3" : "#ffffff", // <-- updated color here
                                            cursor: "pointer",
                                            color: selectedDoc === item?.uid ? "#ffffff" : "#000000", // optional: white text when selected
                                        }}
                                        onClick={() => setSelectedDoc(item?.uid)}
                                    >
                                        {item.feature_name?.length > 30 ?
                                            <Tooltip title={item?.feature_name}>
                                                {item?.feature_name?.slice(0, 30)}...
                                            </Tooltip>
                                            : item?.feature_name}
                                    </List.Item>
                                )}
                            />

                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default HelpDocView;
